import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import { withRouter } from 'react-router-dom';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import CustomerReviewCard from './CustomerReviewCard';

class CustomerReviewsList extends React.Component {
  reviewsList = [];

  render() {
    const {
      type,
      loadMore,
      reviews,
      loading,
      error,
      networkStatus,
      totalReviewsCount,
    } = this.props.config;

    if (networkStatus === 4) return 'Updating page!';
    if (loading)
      return (
        <div className="flex flex-col items-center justify-center p-8 min-h-[20vh]">
          <ProgressLoader />
        </div>
      );
    if (error) return `Error!: ${error}`;
    if (reviews) {
      this.reviewsList = reviews.map(reviewValue => {
        /*
        CN-841 - Put all product details coming from graphql and send to reviews page - for making png images.
        */
        const product = {
          name: reviewValue.product_name,
          id: reviewValue.product_id,
          options: reviewValue.options,
        };

        return (
          <CustomerReviewCard
            key={reviewValue?.reviews[0]?.id}
            type={type}
            productReview={reviewValue}
            product={product}
            staticContext={this.props.staticContext}
          />
        );
      });
    }
    return (
      <div className="flex flex-col items-center px-0 py-5 max-w-[1400px] mt-0 mx-[3.333vw] mb-8 min-[1440px]:mt-0 min-[1440px]:mx-auto min-[1440px]:mb-[6.25rem]">
        <InfiniteScroll
          dataLength={reviews.length ? reviews.length : 0}
          next={loadMore}
          hasMore={!!loadMore}
        >
          <div className="customer-reviews-grid">
            {this.reviewsList.length ? this.reviewsList : null}
          </div>
        </InfiniteScroll>
        {totalReviewsCount > this.reviewsList.length ? (
          <div className="px-0 py-4">
            <button
              type="button"
              className="text-base [background:none] border-0 text-gray-light1 mt-4 p-2 hover:cursor-pointer hover:text-gray-dark focus-visible:text-gray-dark"
              onClick={loadMore}
              aria-label="Load more reviews above"
            >
              Load more
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

CustomerReviewsList.propTypes = {
  config: PropTypes.shape({
    error: PropTypes.string,
    loading: PropTypes.bool,
    loadMore: PropTypes.func,
    networkStatus: PropTypes.number,
    reviews: PropTypes.array,
    totalReviewsCount: PropTypes.number,
    type: PropTypes.string,
  }),
  staticContext: PropTypes.object,
};

export default withRouter(CustomerReviewsList);
